import user from "./user";
import order from "./order";
import activity from "./activity";
import admin from "./admin";
import community from "./community";

export default [...user, ...order, ...activity, ...admin, ...community];
